import React, { Component } from 'react';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';

class ReportDetailpage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        const header = (
            <div className="page_header">
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.report.text}</li>
                </ol>
                <h2> {LOOKUP.report.text}</h2>
            </div>
        );

        return (
            <ContainerDivided headerContent={header}>
                <p>Here comes the table</p>
            </ContainerDivided>
        );
    }
}


export default ReportDetailpage;